import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { answersReducer, initialState } from './reducer';

export const QAStateContext = React.createContext();
export const QADispatchContext = React.createContext();

function QAProvider({ children }) {
  const [state, dispatch] = React.useReducer(answersReducer, initialState);

  return (
    <QAStateContext.Provider value={state}>
      <QADispatchContext.Provider value={dispatch}>{children}</QADispatchContext.Provider>
    </QAStateContext.Provider>
  );
}

QAProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * This is just a helper that allows us to condense the state & dispatch into one line
 */
const useQAContext = () => {
  const contextState = useContext(QAStateContext);
  const contextDispatch = useContext(QADispatchContext);

  return [contextState, contextDispatch];
};

export { QAProvider, useQAContext };
